<template>
  <div id="container">
    <div class="column">
      <div class="single-group">Users</div>
      <div class="master-list">
        <ul>
          <li
            v-for="user in filteredUsers"
            :key="user.UserID"
            class="child row user hoverable"
            :class="{ selected: user.UserID === selectedUser.UserID }"
            @click="selectedUser = user"
          >
            <span class="name">{{ user.LastName }}, {{ user.FirstName }}</span>
            <span class="user-id">{{ user.UserID }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="column">
      <!-- <div id='perm-options'> -->
      <input
        v-model="filterText"
        placeholder="Filter Users"
        class="text-input"
      />
      <div
        v-if="selectedUser"
        id="current"
      >
        <b>Permissions for: {{ selectedUser.LastName }}, {{ selectedUser.FirstName }}</b>
      </div>
      <!-- </div> -->

      <ul class="master-list">
        <li
          v-for="(cat, i) in groups"
          :key="i"
        >
          <div class="group">
            {{ cat.Category }}
          </div>
          <ul>
            <li
              v-for="(role, i) in cat.Permissions"
              :key="i"
              :title="role.Description"
              class="child"
            >
              <span :class="{ disabled: !role.IsGranted }">{{ role.PermissionName }}</span>
              <br />
              <small v-if="role.Source !== null">- {{ role.Source }}</small>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { notificationsMixin } from 'library/mixins/notifications';
import { httpMixin } from 'library/mixins/http';

export default {
  mixins: [notificationsMixin, httpMixin],
  data() {
    return {
      users: [],
      selectedUser: null,
      groups: [],
      filterText: '',
    };
  },
  computed: {
    filteredUsers: function () {
      if (this.filterText.length === 0 || !this.users) {
        return this.users;
      } else {
        return this.users.filter((u) => {
          let ft = this.filterText.toLowerCase();
          return u.UserID.toLowerCase().includes(ft) || (u.FirstName && u.FirstName.toLowerCase().includes(ft));
        });
      }
    },
    effectivePermissions: function () {
      if (!this.selectedUser) {
        return;
      }
      this.request('/dvsvc/SecUserEffectivePermissions/' + this.selectedUser.UserID).then((resp) => {
        if (resp.IsError) {
          this.notifyDanger('Error: SecUserEffectivePermissions service');
          return;
        }
        const sortedPerm = resp.Permissions.sort((a, b) => {
          if (a.RoleName > b.RoleName) {
            return 1;
          } else if (a.RoleName > b.RoleName) {
            return -1;
          } else {
            return 0;
          }
        });

        const groups = {};

        sortedPerm.forEach((p) => {
          if (Object.keys(groups).indexOf(p.Category) > -1) {
            groups[p.Category].push(p);
          } else {
            groups[p.Category] = [p];
          }
        });
        const groupedPermisionsArr = [];
        Object.keys(groups).forEach((g) => {
          groupedPermisionsArr.push({
            Category: g,
            Permissions: groups[g],
          });
        });
        this.groups = groupedPermisionsArr;
      });
    },
  },
  watch: {
    // deep watch effective permissions because it requires a service call to change object
    effectivePermissions: {
      handler: function (su) {
        // console.log('new selected user', su)
      },
      deep: true,
    },
  },
  created() {
    this.request('/dvsvc/SecUserRoles').then((resp) => {
      if (resp.IsError) {
        this.notifyDanger('Error: SecUserRoles service');
        return;
      }
      this.users = resp.Users.sort((a, b) => {
        if (a.LastName > b.LastName) {
          return 1;
        } else if (a.LastName < b.LastName) {
          return -1;
        } else {
          return 0;
        }
      });
      this.selectedUser = this.users[0];
    });
  },
};
</script>

<style scoped lang="scss"></style>
